// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-page {
  max-width: 1180px;
  margin: 0 auto;
  padding: clamp(72px, 9vw, 118px) clamp(18px, 4vw, 36px) 64px;
  color: var(--color-text-primary);
  font-family: "Geist Sans", "SF Pro Display", "Segoe UI", system-ui, sans-serif;
}

.pricing-hero {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  background: linear-gradient(
    160deg,
    color-mix(in srgb, var(--color-bg-canvas-surface) 92%, var(--color-accent-base)),
    var(--color-bg-canvas-surface) 58%
  );
  border-radius: 10px;
  padding: clamp(30px, 5vw, 56px);
  box-shadow: 0 24px 50px -38px rgba(15, 18, 24, 0.7);
}

.pricing-hero::after {
  content: "";
  position: absolute;
  width: 280px;
  height: 280px;
  top: -110px;
  right: -100px;
  border-radius: 999px;
  background: radial-gradient(
    circle,
    color-mix(in srgb, var(--color-accent-base) 20%, transparent) 0%,
    transparent 72%
  );
  pointer-events: none;
}

.pricing-hero__badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--color-accent-base) 55%, var(--color-border-input));
  color: var(--color-accent-base);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 6px 12px;
  margin-bottom: 16px;
  background: color-mix(in srgb, var(--color-accent-base) 10%, transparent);
}

.pricing-hero__title {
  margin: 0;
  font-family: "Geist Sans", "Times New Roman", serif;
  font-size: clamp(34px, 5vw, 58px);
  line-height: 1.06;
  letter-spacing: -0.015em;
}

.pricing-hero__title span {
  font-style: italic;
  color: var(--color-accent-base);
}

.pricing-hero__subtitle {
  max-width: 760px;
  margin: 16px 0 0;
  font-size: clamp(14px, 1.8vw, 17px);
  line-height: 1.68;
  color: var(--color-text-secondary);
}

.pricing-hero__chips {
  margin-top: 26px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.pricing-chip {
  border: 1px solid var(--color-border-input);
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 88%, transparent);
  backdrop-filter: blur(3px);
  border-radius: 8px;
  padding: 12px 13px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pricing-chip__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
  font-weight: 600;
}

.pricing-chip strong {
  font-size: 14px;
  font-weight: 600;
}

.pricing-free-models {
  margin-top: 20px;
  border-radius: 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  padding: 22px;
}

.pricing-free-models__header h2 {
  margin: 0;
  font-family: "Geist Sans", "Times New Roman", serif;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 400;
}

.pricing-free-models__header p {
  margin: 8px 0 0;
  font-size: 14px;
  color: var(--color-text-secondary);
}

.pricing-free-models__list {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pricing-free-models__item {
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  background: color-mix(in srgb, var(--color-accent-base) 10%, transparent);
  color: var(--color-text-primary);
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
}

.pricing-highlights {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.pricing-highlight-card {
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  border-radius: 10px;
  padding: 18px 16px;
}

.pricing-highlight-card__kicker {
  display: inline-block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
  margin-bottom: 10px;
}

.pricing-highlight-card h3 {
  margin: 0;
  font-family: "Geist Sans", "Times New Roman", serif;
  font-size: 24px;
  line-height: 1.18;
  font-weight: 400;
}

.pricing-highlight-card p {
  margin: 8px 0 0;
  color: var(--color-accent-base);
  font-size: 15px;
  font-weight: 700;
}

.pricing-table-section {
  margin-top: 18px;
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  background: var(--color-bg-canvas-surface);
  overflow: hidden;
}

.pricing-table-section__header {
  padding: 18px 18px 12px;
}

.pricing-table-section__heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.pricing-table-section__header h2 {
  margin: 0;
  font-family: "Geist Sans", "Times New Roman", serif;
  font-size: clamp(24px, 2.8vw, 34px);
  font-weight: 400;
}

.pricing-table-section__header p {
  margin: 7px 0 0;
  font-size: 14px;
  color: var(--color-text-secondary);
}

.pricing-table-search {
  min-width: min(100%, 340px);
  flex: 1 1;
  max-width: 360px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--color-border-input);
  background: color-mix(in srgb, var(--color-bg-root) 64%, var(--color-bg-canvas-surface));
  border-radius: 999px;
  padding: 9px 12px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.pricing-table-search__icon {
  font-size: 14px;
  line-height: 1;
  color: var(--color-text-secondary);
}

.pricing-table-search input {
  border: none;
  background: transparent;
  width: 100%;
  color: var(--color-text-primary);
  font-size: 13px;
  outline: none;
}

.pricing-table-search input::placeholder {
  color: var(--color-text-secondary);
}

.pricing-table-wrapper {
  overflow-x: auto;
  border-top: 1px solid var(--color-border-input);
}

.pricing-table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
  font-size: 13px;
}

.pricing-table th,
.pricing-table td {
  text-align: left;
  padding: 12px 14px;
  border-bottom: 1px solid var(--color-border-input);
}

.pricing-table th {
  background: color-mix(in srgb, var(--color-bg-root) 58%, var(--color-bg-canvas-surface));
}

.pricing-table td {
  color: var(--color-text-primary);
}

.pricing-sort-button {
  appearance: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  text-align: left;
  cursor: pointer;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: var(--color-text-secondary);
}

.pricing-sort-button span {
  font-size: 12px;
  color: color-mix(in srgb, var(--color-text-secondary) 70%, var(--color-accent-base));
}

.pricing-sort-button:hover {
  color: var(--color-text-primary);
}

.pricing-sort-button:focus-visible {
  outline: 2px solid var(--color-accent-base);
  outline-offset: 2px;
  border-radius: 4px;
}

.pricing-table td code {
  font-size: 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-root);
  border-radius: 5px;
  padding: 3px 7px;
}

.pricing-table tbody tr:hover {
  background: color-mix(in srgb, var(--color-accent-base) 8%, transparent);
}

.pricing-table tbody tr:last-child td {
  border-bottom: none;
}

.pricing-table__empty {
  text-align: center !important;
  color: var(--color-text-secondary) !important;
  padding: 20px !important;
  font-style: italic;
}

.pricing-table-note {
  padding: 12px 18px 14px;
  border-top: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.55;
}

.pricing-table-note strong {
  color: var(--color-text-primary);
}

.pricing-cta {
  margin-top: 18px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  border-radius: 10px;
  padding: 24px;
  text-align: center;
}

.pricing-cta h2 {
  margin: 0;
  font-family: "Geist Sans", "Times New Roman", serif;
  font-size: clamp(27px, 3vw, 38px);
  font-weight: 400;
}

.pricing-cta p {
  margin: 10px auto 0;
  max-width: 680px;
  color: var(--color-text-secondary);
  line-height: 1.6;
}

.pricing-cta__button {
  margin-top: 16px;
  display: inline-flex;
  text-decoration: none;
  border: 1px solid var(--color-border-input);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 13px;
  font-weight: 600;
  padding: 11px 17px;
  border-radius: 6px;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.pricing-cta__button:hover {
  transform: translateY(-1px);
  opacity: 0.95;
}

@media (max-width: 980px) {
  .pricing-hero__chips,
  .pricing-highlights {
    grid-template-columns: 1fr;
  }

  .pricing-table-search {
    max-width: 100%;
  }
}

@media (max-width: 700px) {
  .pricing-page {
    padding: 18px 14px 42px;
  }

  .pricing-hero {
    padding: 22px 16px;
  }

  .pricing-table-section__header,
  .pricing-free-models,
  .pricing-cta {
    padding-left: 14px;
    padding-right: 14px;
  }

  .pricing-plans {
    flex-direction: column;
  }
}

/* ── Plan Cards ── */
.pricing-plans {
  display: flex;
  gap: 20px;
  margin: 40px 0;
  align-items: stretch;
}

.pricing-plan-card {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  padding: 28px 24px;
  background: var(--color-bg-canvas-surface);
  transition: border-color 0.2s;
}

.pricing-plan-card:hover {
  border-color: var(--color-accent-base);
}

.pricing-plan-card--featured {
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 1px var(--color-accent-base), 0 12px 40px -16px rgba(15, 18, 24, 0.6);
}

.pricing-plan-card__badge {
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--color-accent-base);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 3px 14px;
  border-radius: 20px;
  white-space: nowrap;
}

.pricing-plan-card__header {
  margin-bottom: 20px;
}

.pricing-plan-card__header h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px;
  color: var(--color-text-primary);
}

.pricing-plan-card__price {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.pricing-plan-card__amount {
  font-size: 36px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1;
}

.pricing-plan-card__period {
  font-size: 14px;
  color: var(--color-text-secondary);
}

.pricing-plan-card__features {
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pricing-plan-card__features li {
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  padding-left: 20px;
  position: relative;
}

.pricing-plan-card__features li::before {
  content: "\\2713";
  position: absolute;
  left: 0;
  color: var(--color-accent-base);
  font-weight: 600;
}

.pricing-plan-card__features li strong {
  color: var(--color-text-primary);
}

.pricing-plan-card__button {
  display: block;
  text-align: center;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: none;
  transition: opacity 0.15s;
}

.pricing-plan-card__button:hover {
  opacity: 0.85;
}

.pricing-plan-card__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pricing-plan-card__button--primary {
  background: var(--color-accent-base);
  color: #fff;
}

.pricing-plan-card__button--secondary {
  background: transparent;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/PricingPage.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4DAA4D;EAC5D,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C;;;;GAIC;EACD,mBAAmB;EACnB,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,6FAA6F;EAC7F,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,yEAAyE;AAC3E;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,iCAAiC;EACjC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,+EAA+E;EAC/E,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,yEAAyE;EACzE,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,wFAAwF;EACxF,oBAAoB;EACpB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap\");\n\n.pricing-page {\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: clamp(72px, 9vw, 118px) clamp(18px, 4vw, 36px) 64px;\n  color: var(--color-text-primary);\n  font-family: \"Geist Sans\", \"SF Pro Display\", \"Segoe UI\", system-ui, sans-serif;\n}\n\n.pricing-hero {\n  position: relative;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  background: linear-gradient(\n    160deg,\n    color-mix(in srgb, var(--color-bg-canvas-surface) 92%, var(--color-accent-base)),\n    var(--color-bg-canvas-surface) 58%\n  );\n  border-radius: 10px;\n  padding: clamp(30px, 5vw, 56px);\n  box-shadow: 0 24px 50px -38px rgba(15, 18, 24, 0.7);\n}\n\n.pricing-hero::after {\n  content: \"\";\n  position: absolute;\n  width: 280px;\n  height: 280px;\n  top: -110px;\n  right: -100px;\n  border-radius: 999px;\n  background: radial-gradient(\n    circle,\n    color-mix(in srgb, var(--color-accent-base) 20%, transparent) 0%,\n    transparent 72%\n  );\n  pointer-events: none;\n}\n\n.pricing-hero__badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--color-accent-base) 55%, var(--color-border-input));\n  color: var(--color-accent-base);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 6px 12px;\n  margin-bottom: 16px;\n  background: color-mix(in srgb, var(--color-accent-base) 10%, transparent);\n}\n\n.pricing-hero__title {\n  margin: 0;\n  font-family: \"Geist Sans\", \"Times New Roman\", serif;\n  font-size: clamp(34px, 5vw, 58px);\n  line-height: 1.06;\n  letter-spacing: -0.015em;\n}\n\n.pricing-hero__title span {\n  font-style: italic;\n  color: var(--color-accent-base);\n}\n\n.pricing-hero__subtitle {\n  max-width: 760px;\n  margin: 16px 0 0;\n  font-size: clamp(14px, 1.8vw, 17px);\n  line-height: 1.68;\n  color: var(--color-text-secondary);\n}\n\n.pricing-hero__chips {\n  margin-top: 26px;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.pricing-chip {\n  border: 1px solid var(--color-border-input);\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 88%, transparent);\n  backdrop-filter: blur(3px);\n  border-radius: 8px;\n  padding: 12px 13px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pricing-chip__label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-secondary);\n  font-weight: 600;\n}\n\n.pricing-chip strong {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.pricing-free-models {\n  margin-top: 20px;\n  border-radius: 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  padding: 22px;\n}\n\n.pricing-free-models__header h2 {\n  margin: 0;\n  font-family: \"Geist Sans\", \"Times New Roman\", serif;\n  font-size: clamp(24px, 3vw, 32px);\n  font-weight: 400;\n}\n\n.pricing-free-models__header p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n.pricing-free-models__list {\n  margin-top: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.pricing-free-models__item {\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--color-accent-base) 10%, transparent);\n  color: var(--color-text-primary);\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pricing-highlights {\n  margin-top: 18px;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.pricing-highlight-card {\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  border-radius: 10px;\n  padding: 18px 16px;\n}\n\n.pricing-highlight-card__kicker {\n  display: inline-block;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-secondary);\n  margin-bottom: 10px;\n}\n\n.pricing-highlight-card h3 {\n  margin: 0;\n  font-family: \"Geist Sans\", \"Times New Roman\", serif;\n  font-size: 24px;\n  line-height: 1.18;\n  font-weight: 400;\n}\n\n.pricing-highlight-card p {\n  margin: 8px 0 0;\n  color: var(--color-accent-base);\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.pricing-table-section {\n  margin-top: 18px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  background: var(--color-bg-canvas-surface);\n  overflow: hidden;\n}\n\n.pricing-table-section__header {\n  padding: 18px 18px 12px;\n}\n\n.pricing-table-section__heading {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.pricing-table-section__header h2 {\n  margin: 0;\n  font-family: \"Geist Sans\", \"Times New Roman\", serif;\n  font-size: clamp(24px, 2.8vw, 34px);\n  font-weight: 400;\n}\n\n.pricing-table-section__header p {\n  margin: 7px 0 0;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n.pricing-table-search {\n  min-width: min(100%, 340px);\n  flex: 1;\n  max-width: 360px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--color-border-input);\n  background: color-mix(in srgb, var(--color-bg-root) 64%, var(--color-bg-canvas-surface));\n  border-radius: 999px;\n  padding: 9px 12px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.pricing-table-search__icon {\n  font-size: 14px;\n  line-height: 1;\n  color: var(--color-text-secondary);\n}\n\n.pricing-table-search input {\n  border: none;\n  background: transparent;\n  width: 100%;\n  color: var(--color-text-primary);\n  font-size: 13px;\n  outline: none;\n}\n\n.pricing-table-search input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.pricing-table-wrapper {\n  overflow-x: auto;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.pricing-table {\n  width: 100%;\n  min-width: 860px;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.pricing-table th,\n.pricing-table td {\n  text-align: left;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.pricing-table th {\n  background: color-mix(in srgb, var(--color-bg-root) 58%, var(--color-bg-canvas-surface));\n}\n\n.pricing-table td {\n  color: var(--color-text-primary);\n}\n\n.pricing-sort-button {\n  appearance: none;\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  text-align: left;\n  cursor: pointer;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n}\n\n.pricing-sort-button span {\n  font-size: 12px;\n  color: color-mix(in srgb, var(--color-text-secondary) 70%, var(--color-accent-base));\n}\n\n.pricing-sort-button:hover {\n  color: var(--color-text-primary);\n}\n\n.pricing-sort-button:focus-visible {\n  outline: 2px solid var(--color-accent-base);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.pricing-table td code {\n  font-size: 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-root);\n  border-radius: 5px;\n  padding: 3px 7px;\n}\n\n.pricing-table tbody tr:hover {\n  background: color-mix(in srgb, var(--color-accent-base) 8%, transparent);\n}\n\n.pricing-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.pricing-table__empty {\n  text-align: center !important;\n  color: var(--color-text-secondary) !important;\n  padding: 20px !important;\n  font-style: italic;\n}\n\n.pricing-table-note {\n  padding: 12px 18px 14px;\n  border-top: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.55;\n}\n\n.pricing-table-note strong {\n  color: var(--color-text-primary);\n}\n\n.pricing-cta {\n  margin-top: 18px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  border-radius: 10px;\n  padding: 24px;\n  text-align: center;\n}\n\n.pricing-cta h2 {\n  margin: 0;\n  font-family: \"Geist Sans\", \"Times New Roman\", serif;\n  font-size: clamp(27px, 3vw, 38px);\n  font-weight: 400;\n}\n\n.pricing-cta p {\n  margin: 10px auto 0;\n  max-width: 680px;\n  color: var(--color-text-secondary);\n  line-height: 1.6;\n}\n\n.pricing-cta__button {\n  margin-top: 16px;\n  display: inline-flex;\n  text-decoration: none;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 13px;\n  font-weight: 600;\n  padding: 11px 17px;\n  border-radius: 6px;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.pricing-cta__button:hover {\n  transform: translateY(-1px);\n  opacity: 0.95;\n}\n\n@media (max-width: 980px) {\n  .pricing-hero__chips,\n  .pricing-highlights {\n    grid-template-columns: 1fr;\n  }\n\n  .pricing-table-search {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 700px) {\n  .pricing-page {\n    padding: 18px 14px 42px;\n  }\n\n  .pricing-hero {\n    padding: 22px 16px;\n  }\n\n  .pricing-table-section__header,\n  .pricing-free-models,\n  .pricing-cta {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .pricing-plans {\n    flex-direction: column;\n  }\n}\n\n/* ── Plan Cards ── */\n.pricing-plans {\n  display: flex;\n  gap: 20px;\n  margin: 40px 0;\n  align-items: stretch;\n}\n\n.pricing-plan-card {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  padding: 28px 24px;\n  background: var(--color-bg-canvas-surface);\n  transition: border-color 0.2s;\n}\n\n.pricing-plan-card:hover {\n  border-color: var(--color-accent-base);\n}\n\n.pricing-plan-card--featured {\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 1px var(--color-accent-base), 0 12px 40px -16px rgba(15, 18, 24, 0.6);\n}\n\n.pricing-plan-card__badge {\n  position: absolute;\n  top: -11px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--color-accent-base);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 3px 14px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.pricing-plan-card__header {\n  margin-bottom: 20px;\n}\n\n.pricing-plan-card__header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 8px;\n  color: var(--color-text-primary);\n}\n\n.pricing-plan-card__price {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.pricing-plan-card__amount {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  line-height: 1;\n}\n\n.pricing-plan-card__period {\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n.pricing-plan-card__features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 24px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pricing-plan-card__features li {\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n  padding-left: 20px;\n  position: relative;\n}\n\n.pricing-plan-card__features li::before {\n  content: \"\\2713\";\n  position: absolute;\n  left: 0;\n  color: var(--color-accent-base);\n  font-weight: 600;\n}\n\n.pricing-plan-card__features li strong {\n  color: var(--color-text-primary);\n}\n\n.pricing-plan-card__button {\n  display: block;\n  text-align: center;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.15s;\n}\n\n.pricing-plan-card__button:hover {\n  opacity: 0.85;\n}\n\n.pricing-plan-card__button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pricing-plan-card__button--primary {\n  background: var(--color-accent-base);\n  color: #fff;\n}\n\n.pricing-plan-card__button--secondary {\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
